import Request from 'utilities/Request';
import {ROLE_IDS} from 'app/Roles';

export const fetchEnvironment = () =>
  Request.get('/api/content/v1/mobile/environment?dingDeviceType=MOBILE_WEB');

export const fetchEnvironmentPublic = cardId =>
  Request.get(`/cards/kpi/${cardId}/environment`);

export const fetchTrialStatus = () =>
  Request.get('/api/content/v3/users/me/trial');

export const beginTrial = () =>
  Request.post('/api/content/v3/users/me/trial', {
    roleId: ROLE_IDS.EDITOR,
    role: 'Editor',
  });

export const requestUpgrade = () =>
  Request.post('/api/content/v3/users/me/request-more-access');
